<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-1/3 w-full">
                <vx-card :title="channelPackage.name" id="packageDiv"  class="vs-con-loading__container">
                    <table class="simple-table" v-if="!editEnabled">
                        <tr>
                            <td class="font-semibold">Days:</td>
                            <td>{{ channelPackage.days }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Credits:</td>
                            <td>{{ channelPackage.credits }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Trial enabled:</td>
                            <td>
                                <vs-chip color="success" v-if="channelPackage.trial_enabled">Yes</vs-chip>
                                <vs-chip color="danger" v-else>No</vs-chip>
                            </td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Trial days:</td>
                            <td>{{ channelPackage.trial_days }}</td>
                        </tr>
                    </table>
                    <div v-else>
                        <p class="mt-6">Name</p>
                        <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                        <p class="mt-6">Days</p>
                        <vs-input v-model="editObject['days']" class="w-full"></vs-input>
                        <p class="mt-6">Credits</p>
                        <vs-input v-model="editObject['credits']" class="w-full"></vs-input>

                        <div class="vx-row mt-6">
                            <div class="vx-col w-1/3 mt-1">
                                <vs-checkbox class="mt-6" v-model="editObject['trial_enabled']">Trial enabled</vs-checkbox>
                            </div>
                            <div class="vx-col w-2/3">
                                <p>Trial days</p>
                                <vs-input :disabled="!editObject['trial_enabled']" v-model="editObject['trial_days']" class="w-full"></vs-input>
                            </div>
                        </div>
                    </div>
                    <vs-divider/>
                    <vs-button icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="savePackage">Save</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removePackage">Remove</vs-button>
                    <div style="clear: both"></div>
                </vx-card>
            </div>
            <div class="vx-col w-full mt-6">
                <vx-card title="Channels" id="packageChannelsDiv"  class="vs-con-loading__container">

                    <vs-button color="success" icon-pack="feather" icon="icon-save" class="mb-3" @click="saveChannels">Save</vs-button>

                    <div class="vx-row">
                        <div class="vx-col w-6/12">
                            <vs-list>
                                <vs-list-header title="Package channels" color="primary"></vs-list-header>

                                <table class="w-full" cellspacing="0">
                                    <draggable :list="packageChannels" group="channels" class="p-2 cursor-move" tag="tbody">
                                        <tr v-for="(listItem, index) in packageChannels" :key="index">

                                            <td style="border-bottom: #d2d2d2 1px solid; border-right: 0">
                                                <vs-avatar color="primary" style="width: 33px" class="mr-6" :text="'' + (index+1)" />
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <img v-if="listItem.image_name.length > 0" style="height: 40px;" :src="'/api/management/v1/channel_logo/' + listItem.image_name" :alt="listItem.image_nameworker_channel_name">
                                                <img v-else style="height: 40px;" src="@/assets/images/pages/tvIcon.png" :alt="listItem.image_nameworker_channel_name">
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <p class="font-semibold"> {{listItem.worker_channel_name}}</p>
                                                <p> {{listItem.worker_name}}</p>
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <p class="font-semibold"> {{listItem.category}}</p>
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <vs-button color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeChannel(index)"/>
                                            </td>

                                        </tr>
                                    </draggable>
                                </table>


                            </vs-list>
                        </div>
                        <div class="vx-col w-6/12">
                            <vs-list>
                                <vs-list-header title="Available channels" color="primary"></vs-list-header>

                                <table class="w-full" cellspacing="0">
                                    <draggable :list="availablePackageChannels" group="channels" class="p-2 cursor-move" tag="tbody">
                                        <tr v-for="(listItem, index) in availablePackageChannels" :key="index">

                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <img v-if="listItem.image_name.length > 0" style="height: 40px;" :src="'/api/management/v1/channel_logo/' + listItem.image_name" :alt="listItem.image_nameworker_channel_name">
                                                <img v-else style="height: 40px;" src="@/assets/images/pages/tvIcon.png" :alt="listItem.image_nameworker_channel_name">
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <p class="font-semibold"> {{listItem.worker_channel_name}}</p>
                                                <p> {{listItem.worker_name}}</p>
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <p class="font-semibold"> {{listItem.category}}</p>
                                            </td>
                                            <td style="border-bottom: #d2d2d2 1px solid">
                                                <vs-button color="success" icon-pack="feather" icon="icon-plus" @click="addChannel(index)"/>
                                            </td>
                                        </tr>
                                    </draggable>
                                </table>

                            </vs-list>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    import draggable from 'vuedraggable'

    export default {
        components: {
            draggable
        },
        data() {
            return {

                channelPackage: {
                    name: '',
                    days: 0,
                    credits: 0,
                    trial_enabled: false,
                    trial_days: 0
                },

                editObject: {},
                editEnabled: false,

                packageChannels: [],
                availablePackageChannels: []

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#packageDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/package/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.channelPackage = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packageDiv > .con-vs-loading')
                })
            },
            loadChannels() {
                this.$vs.loading({
                    container: '#packageChannelsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const channelsPromise = this.$http.get('/api/management/v1/package/' + this.$route.params.id + '/channels')
                channelsPromise.then(function(response) {
                    thisIns.packageChannels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const availableChannelsPromise = this.$http.get('/api/management/v1/package/' + this.$route.params.id + '/channels/available')
                availableChannelsPromise.then(function(response) {
                    thisIns.availablePackageChannels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([channelsPromise, availableChannelsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#packageChannelsDiv > .con-vs-loading')
                })
            },
            saveChannels() {
                this.$vs.loading({
                    container: '#packageChannelsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                for (let x = 0; x < this.packageChannels.length; x++) {
                    this.packageChannels[x].index = x
                }

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/package/' + this.$route.params.id + '/channels', this.packageChannels)
                savePromise.then(function() {
                    thisIns.$printSuccess('Channels saved!')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packageChannelsDiv > .con-vs-loading')
                })
            },
            removeChannel(index) {
                this.availablePackageChannels.push(...this.packageChannels.splice(index, 1))
            },
            addChannel(index) {
                this.packageChannels.push(...this.availablePackageChannels.splice(index, 1))
            },
            savePackage() {
                this.$vs.loading({
                    container: '#packageDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/package/' + this.$route.params.id, {
                    name: this.editObject.name,
                    days: Number(this.editObject.days),
                    credits: Number(this.editObject.credits),
                    trial_enabled: this.editObject.trial_enabled,
                    trial_days: Number(this.editObject.trial_days)
                })

                savePromise.then(function() {
                    thisIns.$printSuccess('Package saved')
                    thisIns.editEnabled = false
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packageDiv > .con-vs-loading')
                })
            },
            removePackage() {
                const thisIns = this
                const removePromise = this.$http.delete('/api/management/v1/package/' + this.$route.params.id)
                removePromise.then(function() {
                    thisIns.$printSuccess('Package removed')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/packages')
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            }

        },
        mounted() {
            this.loadData()
            this.loadChannels()
        }
    }

</script>
<style lang="scss">
    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

</style>
